module.exports = __webpack_public_path__ + "900049ef8c664c2dd7ba9fb56ac992ff.MP3";